<template>
  <div class="p-0 m-0">
    <!-- <div class="Vendor-Dashboard-21 container-fluid"> -->
      
    <div class="row p-0">
      <!-- <div class="col-2"> -->

      <div class="card card-side-bar ml-2">
        <h4 class="pl-3 mt-3 tree-header">My Profile</h4>
        <!-- <div class="col-3"> -->
        <!-- <v-select :items="partnerTypes" label="Standard"></v-select> -->

        <dynamicdropdown
          :options="partnerTypes"
          @dropdownChange="getPartnerSelectedType($event)"
          validation="required"
          :selected="selectedPartnerType"
          class="mx-2"
          :labelName="'Partner Type'"
          v-if="this.categoryCode!=5 && this.categoryCode!='5'"
        />
        <div>
          <div :class="ativeParrent(index)" v-for="(item,index) in modules" :key="index">
            <div class="m-0 p-2" @click="showChildren(item.id,index)">
              <span class="mt-2 quick-links">{{item && item.name ? item.name : "-"}}</span>
              <span v-if="item && item.children && item.children.length > 0">
                <img
                  v-if="currentIndex == index"
                  style="float: right;"
                  alt
                  src="@/assets/arrow-up.svg"
                />
                <img v-else style="float: right;" alt src="@/assets/arrow-down.svg" />
              </span>
            </div>
            <span v-if="item && item.children && item.children.length > 0 && currentIndex == index">
              <div
                class="sub-children-text"
                v-for="(sub,i) in modules[currentIndex].children"
                :key="i"
                @click="showActiveGroup(sub.id,sub.moduleCode)"
              >
                <span class="border-color"></span>
                <h4 class="pl-3 py-2 pt-2 sub-children-text">{{sub.name}}</h4>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div class="col-10 ml-3 m-0 p-0">
        <!--b-button @click="navigateToEIP()" class="eip-link mr-5 float-right mt-3">EIP</b-button-->
        <div v-if="selecteddata == '1'" class="header-top mt-3">Organisation Details</div>
        <div v-if="selecteddata == '2'" class="header-top mt-3">Bank Details</div>
        <div v-if="selecteddata == '4'" class="header-top mt-3">Partnership Avenues</div>
        <div v-if="selecteddata == '3'" class="header-top mt-3">Credentials</div>
        <div v-if="selecteddata == '5'" class="header-top mt-3">Financial Performance</div>
        <div v-if="selecteddata == '6'" class="header-top mt-3">Financial Strength</div>
        <div v-if="selecteddata == '10'" class="header-top mt-3">Others</div>
        <div v-if="selecteddata == '100'" class="header-top mt-3">QuickLinks</div>
        <div v-if="selecteddata == '999'" class="header-top mt-3">Re-KYC Dashboard</div>
        <div v-if="selecteddata == '101'" class="header-top p-0 m-0 pt-3">GST Registration</div>
        <div v-if="selecteddata == '102'" class="header-top p-0 m-0 pt-3">Business Category</div>
        <div v-if="selecteddata != 10" class="header-top mt-2">{{summary.groupName}}</div>
        <v-card class="card card-main-layout">
          <div v-if="selecteddata == '1'">
            <organisationDetails :organizationDetail="summary" :branchLogIn="branchLogIn" />
          </div>
          <div v-if="selecteddata == '2'">
            <bankDetails :bankDetail="summary" />
          </div>
          <div v-if="selecteddata == '3'">
            <partnershipAvenues :partnershipAvenue="summary" :branchLogIn="branchLogIn" />
          </div>
          <div v-if="selecteddata == '4'">
            <credentials :credential="summary" :branchLogIn="branchLogIn" />
          </div>
          <div v-if="selecteddata == '5'">
            <financialPerformance :financialPerformance="summary" :organizationDetail="summary"/>
          </div>
          <div v-if="selecteddata == '6'">
            <financialStrength :financialStrength="summary" :branchLogIn="branchLogIn" />
          </div>
          <div v-if="selecteddata == '10' && summary.groupCode != 10">
            <financialOthers :financialOther="summary" />
          </div>
          <div v-if="selecteddata == '100'">
            <quickLink :quickLinkDetails="summary" :currentCategoryCode="categoryCode" 
            :summary="summary" :primaryBusiness="primaryBusiness"/>
          </div>
          <div v-if="selecteddata == '999'">
             <rekyc
      :title="'Re-KYC'" 
      :modalSize="'xl'"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      @eventKYCClose="handleDeclarationModel()"
      :companyCode="companycode"
      :partnerId="partnerId"
      :isInternational="this.$root.isInternational"
    />
          </div>
          <div v-if="selecteddata == '101'">
            <c-gst :trigger="openGSTDetails" />
          </div>
          <div v-if="selecteddata == '102'">
            <c-businessCategory />
          </div>
          <div v-if="selecteddata">
            <devDynamicModule :dynamicModule="summary" />
          </div>
        </v-card>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
    <w-modal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="closeTriggerdModal()"
    />
  </div>
</template>

<script>
import axios from "axios";
import organisationDetails from "../../components/partnerProfile/organizationDetails";
import bankDetails from "../../components/partnerProfile/bankDetails";
import partnershipAvenues from "../../components/partnerProfile/partnershipAvenues";
import credentials from "../../components/partnerProfile/credentials";
import dynamicModule from "../../components/partnerProfile/dynamicModule";
import financialPerformance from "../../components/partnerProfile/financialPerformance";
import financialStrength from "../../components/partnerProfile/financialStrength";
import financialOthers from "../../components/partnerProfile/financialOthers";
import loadingSpinner from "../../widgets/LoadingSpinner";
import devDynamicModule from "../../components/partnerProfile/devDynamicModule";
import quickLink from "../../components/partnerProfile/quickLink";
import gstDetails from "../../components/partnerProfile/gstDetails";
// import gstDetails from "../../components/summary/gstApproval";
import businessCategoryDetails from "../../components/partnerProfile/businessCategory";
import { PartnerService } from "../../services/partnerService";
import dynamicdropdown from "../../widgets/dropdownpartner";
import Modal from "../../widgets/newModalWidget";
import rekyc from "../../widgets/ReKycComponent";

const partnerService = new PartnerService();
export default {
  components: {
    organisationDetails,
    rekyc,
    bankDetails,
    partnershipAvenues,
    credentials,
    dynamicModule,
    financialPerformance,
    financialStrength,
    financialOthers,
    quickLink,
    "w-loadingSpinner": loadingSpinner,
    dynamicdropdown,
    devDynamicModule,
    "c-gst": gstDetails,
    "c-businessCategory": businessCategoryDetails,
    "w-modal": Modal
  },
  data() {
    return {
      partnerId: '',
      primaryBusiness:{},
      branchLogIn: false,
      tree: [],
      open: [],
      active: [],
      modules: [],
      summary: [],
      organisationDetails: [],
      bankDetails: [],
      partnershipAvenues: [],
      Credentials: [],
      userName: "shew",
      requestNumber: "POB190102000001",
      categoryCode: "",
      companycode: "",
      partnerNumber: "",
      subModules: "",
      parentId: "",
      moduleCode: "",
      groupCode: "",
      selecteddata: "",
      loading: false,
      openGSTDetails: false,
      openBusinessCategory: false,
      partnerTypes: [
        { value: null, text: "Select Partner", disabled: true }
        // { value: 1, text: "Supplier" },
        // { value: 2, text: "Service Povider" }
      ],
      showsubChild: [],
      triggerModal: false,
      alertModal: false,
      successModal: false,
      lastResponse: "",
      currentIndex: 0
    };
  },
  computed: {
    selected() {
      console.log("selected");
      if (!this.active.length) return undefined;
      const id = this.active[0];
      console.log("Selected id", id);
      return id;
    }
  },
  created() {
    this.getPartnerInfo();
    this.loading = true;
    var self = this
    EventBus.$on('switchCompany',function(e){      
    self.getPartnerInfo();
    })
    // this.getQuickLinkPage();
  },
  methods: {
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    closeTriggerdModal() {
      this.triggerModal = false;
      this.alertModal = false;
      this.successModal = false;
      this.triggerApprovedOne();
    },
    getPartnerSelectedType(event) {
      
      partnerService.categorySwitch(this.companycode).then(resp => {
        if(resp.status == "SUCCESS") {
      this.categoryCode = "";
      this.partnerTypes.forEach((item, index) => {
        if (item.value == event) {
          // naviagte to onboard          
          this.selectedPartnerType = item
          if (
            item.evaluationStatus == "N" ||
            item.evaluationStatus == null ||
            item.evaluationStatus == "C" ||
            item.evaluationStatus == "S"
          ) {
            this.$router.push({
              name: "DashboardPage",
              params: {
                onboardStatus: "OnProgress",
                currentCategoryCode: item.value,
                currentCategoryName: item.text,
                currentCompanyCode: this.companycode
              }
            });
          } else if (item.evaluationStatus == "R") {
            this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = `Your request for enrollment as ${item.text} is Rejected..`;
            return;
          } else {
            this.categoryCode = event;
            this.getPartnerSubModules();
            this.getQuickLinkPage();
            this.$forceUpdate();
          }
        }
      });
        } else {
          window.alert('Not able to switch categories. Please contact partner portal support.')
        }
        
      }).catch(err => {
        console.error(err);
      });
    },
    triggerApprovedOne() {
      this.partnerTypes.forEach((item, index) => {
        console.log(item);
        if (item.evaluationStatus == "A") {
          // alert(1);
          console.log(item);
          this.selectedPartnerType = item;
        }
      });
    },
    slectedPartnerType() {
      var selectedPartnerType = [];
      partnerService.getPartnertype(this.companycode).then(resp => {
        if (resp.response) {
          resp.response.forEach((item, index) => {
            if (this.branchLogIn) {
              if (item.status == "A")
                this.partnerTypes.push({
                  text: item.description,
                  value: item.partnerTypeCode,
                  evaluationStatus: item.status
                });
            } else {
              this.partnerTypes.push({
                text: item.description,
                value: item.partnerTypeCode,
                evaluationStatus: item.status
              });
            }
            if (item.status == "A") {
              selectedPartnerType.push({
                text: item.description,
                value: item.partnerTypeCode,
                evaluationStatus: item.status
              });
            }
          });

          // SELECTED FROM PARTNER REMINER
          if (this.$route.params && this.$route.params.selctedBussinessType) {
            var partnerTypeFromReminder = this.$route.params
              .selctedBussinessType;
            this.partnerTypes.forEach((item, index) => {
              if (item.value == partnerTypeFromReminder) {
                this.selectedPartnerType = item.value;
                this.categoryCode = item.value;
              }
              this.loading = false;
            });
          } else {
            // SELECTED WHILE PAGE LOAD
            this.loading = false;
            this.selectedPartnerType = selectedPartnerType[0];
            this.categoryCode = selectedPartnerType[0].value;
          }

          this.getPartnerSubModules();
          this.getQuickLinkPage();
        }
      });
    },
    getPartnerInfo() {
      partnerService.getPartnerInfo().then(resp => {
        this.companycode = resp.response.currentCompanyCode;
        
        this.partnerId = resp.response.partnerId;
        this.primaryBusiness = resp.response.primaryBusiness
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
        this.partnerNumber = resp.response.partnerNumber;
        if (resp.response.partnerCategory == "B") {
          this.branchLogIn = true;
        } else {
          this.branchLogIn = false;
        }
        this.slectedPartnerType();
      });
    },
    getPartnerSubModules() {
      partnerService
        .getPartnerDetails(this.categoryCode)
        .then(resp => {
          console.log("Modules Name List", resp.response);
          const x= resp.response
          var y = []
          var z = []
          y.push(x.filter(item => item.id == 100)[0]);
          //y.push(x.filter(item => item.id == 999)[0]);
          
          z = x.filter(item =>  item.id != 100) //item.id != 999 &&
          y.push(...z)
          this.modules = y;

        })
        .catch(err => {
          console.error(err);
        });
    },
    openNodes() {
      if (this.open.length != 0) {
        if (this.open.length > 1) {
          let lastElement = this.open.pop();
          console.log("lastElement", lastElement);
          this.open = [];
          this.open.push(lastElement);
        }
      }
    },
    navigateToEIP() {
      var audit = sessionStorage.getItem("AuditNumber");
      var auditNumber = this.EncodeUsingAES(audit);
      var vendorCode = this.EncodeUsingAES(this.partnerNumber);
      var company = this.EncodeUsingAES(this.companycode);
      var partnerType =
        this.selectedPartnerType.value == 2 ? "Supplier" : "Service Provider";
      var transcode = this.EncodeUsingAES("VEND_LOGIN");
      var partner = this.EncodeUsingAES(partnerType);
      window.location = `${process.env.VUE_APP_INVOICE_URL}?auditNumber=${auditNumber}&vendorCode=${vendorCode}&PP_TranCode=${transcode}&CompanyCode=${company}&PartnerType=${partner}`;
    },
    EncodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        const keys = atob(process.env.VUE_APP_E_4)
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(value.toString()),
          key,
          {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        return encrypted.toString();
      }
    },
    getQuickLinkPage() {
      this.loading = true;
      this.topFunction();
      this.selecteddata = "";
      partnerService
        .quickLinkPage(this.categoryCode ,this.companycode)
        .then(res => {
          // FOR QUICKLINKS
          if (res.response) {
            this.selecteddata = "100";
            this.summary = res.response;
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch(e => {
          this.loading = false;
        });
    },
    showChildren(id, i) {
      this.currentIndex = i;
      // this.selecteddata = "";
      this.topFunction();
      if (id == 100) {
        this.selecteddata = id;
        this.getQuickLinkPage();
      } else if (id == 101) {
        this.summary = [];
        this.selecteddata = "101";
      } else if (id == 102) {
        this.summary = [];
        this.selecteddata = "102";
      } else if (id == 999) {
        this.selecteddata = "999";
      } 
    },
    showActiveGroup(group, modulecode) {
      // console.log(group);
      // console.log(modulecode);
      this.selecteddata = group;
      this.moduleCode = modulecode;
      this.groupCode = group;
      this.loading = true;
      this.topFunction();
      partnerService
        .getAnswerByModuleCodeAndGroupCode(
          this.moduleCode,
          this.groupCode,
          this.categoryCode
        )
        .then(res => {
          this.summary = res.response;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          console.log(e.message);
        });
    },
    ativeParrent(i) {
      if (i == this.currentIndex) {
        return "ative-sub-children-background";
      } else {
        return "non-ative-sub-children-background";
      }
    },

    addGstDetails() {
      this.openGSTDetails = true;
      this.$forceUpdate();
      // console.log(this.openGSTDetails);
    }
  }
};
</script>
<style scoped>
.v-treeview-node {
  margin-left: 1px !important;
  padding: 2%;
}
.v-treeview-node__root > div > .v-treeview-node__label {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600 !important;
  /* border-bottom: 0.5px solid !important; */
  font-size: 16px !important;
}
.v-treeview-node__children > div > div > div > .v-treeview-node__label {
  font-family: "Source Sans Pro", sans-serif;
  border-bottom: none !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.v-treeview-node__children {
  background-color: #f7f7f7 !important;
}
.v-treeview-node__root > .v-icon.v-icon.v-icon--link {
  cursor: pointer;
  float: right !important;
  text-align: right;
  margin-left: 10%;
  position: fixed;
}
.table td {
  font-family: "Source Sans Pro", sans-serif !important;
}
</style>
<style scoped>
.quick-links {
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: bold;
  /* border-bottom: 0.5px solid !important; */
  font-size: 15px !important;
}
/* .quick-links:hover {
  padding: 3% !important;
  background: rgba(0, 0, 0, 0.12) !important;
} */
.tree-header {
  opacity: 0.7;
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 22px;
  font-weight: bold;
}
.card-side-bar {
  /* width: 245px; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
  font-weight: 500;
  width: 13% !important;
  max-height: 850px !important;
  overflow-y: scroll !important;
  overflow-x: none !important;

  /* overflow: scroll; */
  /* position: fixed; */
  text-align: left;
  padding-left: 10px;
}
.card-main-layout {
  margin-right: 40px;   
   margin-top: 10px;
    padding: 5px 20px;
  background-color: #ffffff;
}
.header-top {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  text-align: left;
}
.header-top-nav {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  background-color: #ffffff;
  text-align: left;
}
.eip-link {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  background-color: #ffffff;
  cursor: pointer;
  border: solid 1px #0e5d84;
  color: #0e5d84;
  font-size: 15px;
  font-weight: bold;
  outline: none;
  width: 80px;
}
.eip-link:hover {
  text-decoration: underline;
}
.login-card-div {
  background-color: #f0f4f7;
  height: 100vh;
}
.card-layout {
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  width: 12%;
  top: 10%;
  padding: 6px;
  margin-left: 10%;
}

.card-layout2 {
  width: 1200px;
  height: 1460px;
  background-color: #ffffff;
  border-radius: 0px;
  padding: 31px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  position: absolute;
  top: 60%;
  bottom: 0;
  left: 21%;
  right: 0;
  margin: auto;
}
.col-sm {
  padding-bottom: 2px;
}
.subModules {
  /* width: 174px;
  height: 20px; */
  margin-bottom: 8px;
  font-family: SourceSansProSemiBold;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 0.16px;
  text-align: left;
  color: #363636;
}
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.06;
  letter-spacing: 0.16px;
  text-align: left;
  color: #000000;
}
.sub-children-text {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
}
.sub-children-text:hover {
  background-color: #dfedf7;
  color: #14436a !important;
  font-weight: 600;
}
.ative-sub-children-background {
  cursor: pointer;
  background-color: #a2d4ec !important;
  padding: 2% !important;
  /* box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.16); */
  /* opacity: 0.1;
  background-color: #0e5d84; */
}
.non-ative-sub-children-background {
  /* box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.16); */
  padding: 2% !important;
}

/* .Vendor-Dashboard-21 {
  width: 1920px;
  height: 1506px;
  background-color: #f4f4f4;
} */
</style>